<template>
  <div :class="columnClassName + ' hub-messages'">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <HubInbox v-if="ready" theme="pos" :subtitle="shopName" show-open-order class="hub-messages-inbox" v-on:open-order="openOrder" />
    <div v-else class="hub-messages-info">
      <p v-if="hubState.problem" class="text-muted">{{ problemText }}</p>
      <p v-else class="text-muted">{{ _('Loading...') }}</p>
      <button v-if="canRetry" type="button" class="btn btn-default" v-on:click="retry">{{ _('Try again') }}</button>
    </div>
  </div>
</template>

<script>
import components from '~/lib/components'
import { useMessaging } from '#hub-messaging/composables/useMessaging'
import { setLocale } from '#hub-messaging/lib/i18n'
import { hubProblemText, hubState, startHubMessaging } from '~/lib/hub'

// The shop's conversations with Johku and its customers: Johku Hub's inbox component (HubInbox,
// from the #hub-messaging layer) in the POS's look, on the shop's messaging session (lib/hub.js).
export default {
  mixins: [components],
  data () {
    return {
      messaging: useMessaging(),
      hubState
    }
  },
  computed: {
    ready () {
      return this.messaging.status === 'ready'
    },
    shopName () {
      const shop = this.messaging.me && this.messaging.me.organisations[0]
      return shop ? shop.name : ''
    },
    problemText () {
      return hubProblemText(this.hubState.problem, this._)
    },
    canRetry () {
      return this.hubState.problem === 'HUB_UNAVAILABLE' || this.hubState.problem === 'HUB_REFUSED'
    }
  },
  created () {
    setLocale(this.$store.state.locale)
    startHubMessaging(this.shopId)
  },
  methods: {
    openOrder (orderId) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'OrderDetails',
        title: this._('Order') + ' ' + orderId,
        width: 6,
        data: { orderId: String(orderId), activeTab: 'conversation' }
      })
    },
    retry () {
      startHubMessaging(this.shopId)
    }
  }
}
</script>

<style scoped>
.hub-messages {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.hub-messages-inbox {
  flex: 1;
  min-height: 0;
}

.hub-messages-info {
  padding: 15px;
}
</style>
